/* eslint-disable max-classes-per-file */
import { IDagKvantitet } from "~app/common/models/dagkvantitet";
import { ForsorjningskallaAggregat, ForsorjningskallaTyp } from "~app/common/models/forsorjningskalla";
import { CommandBase, ICommand } from "../../../../common/services/cqs/commandManager";

export class AddForsorjningskallaProduktionsomradeCommand extends CommandBase {
    produktionsomradeId: number;
    kundorderradId: number;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: AddForsorjningskallaProduktionsomradeCommand) => void) {
        super("AddForsorjningskallaProduktionsomradeCommand");
        init(this);
    }
}

export class AddForsorjningskallaTerminalCommand extends CommandBase {
    mottagningsplatsId: number;
    kundorderradId: number;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: AddForsorjningskallaTerminalCommand) => void) {
        super("AddForsorjningskallaTerminalCommand");
        init(this);
    }
}

export class AddForsorjningskallaLevorderCommand extends CommandBase {
    leverantorsorderradId: number;
    kundorderradId: number;
    fordeladKvantitet: IDagKvantitet[];

    constructor(init: (instance: AddForsorjningskallaLevorderCommand) => void) {
        super("AddForsorjningskallaLevorderCommand");
        init(this);
    }
}

export class AddForsorjningskallaCommandFactory {
    static create(
        model: ForsorjningskallaAggregat,
        kundorderradId: number,
        fordeladKvantitet: IDagKvantitet[]): ICommand {
        switch (model.typ) {
            case ForsorjningskallaTyp.Produktionsomrade:
                return new AddForsorjningskallaProduktionsomradeCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.produktionsomradeId = model.id;
                    c.fordeladKvantitet = fordeladKvantitet;
                });
            case ForsorjningskallaTyp.Terminal:
                return new AddForsorjningskallaTerminalCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.mottagningsplatsId = model.id;
                    c.fordeladKvantitet = fordeladKvantitet;
                });
            case ForsorjningskallaTyp.Leverantorsorder:
                return new AddForsorjningskallaLevorderCommand(c => {
                    c.kundorderradId = kundorderradId;
                    c.leverantorsorderradId = model.id;
                    c.fordeladKvantitet = fordeladKvantitet;
                });
            default:
                throw new Error(`Odefinierad typ: ${model.typ}`);
        }
    }
}
